var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7076 25.2926C20.8005 25.3855 20.8742 25.4958 20.9244 25.6172C20.9747 25.7386 21.0006 25.8687 21.0006 26.0001C21.0006 26.1315 20.9747 26.2616 20.9244 26.383C20.8742 26.5044 20.8005 26.6147 20.7076 26.7076C20.6146 26.8005 20.5043 26.8742 20.383 26.9245C20.2616 26.9747 20.1314 27.0006 20.0001 27.0006C19.8687 27.0006 19.7386 26.9747 19.6172 26.9245C19.4958 26.8742 19.3855 26.8005 19.2926 26.7076L9.29255 16.7076C9.19958 16.6147 9.12582 16.5044 9.07549 16.383C9.02517 16.2616 8.99927 16.1315 8.99927 16.0001C8.99927 15.8687 9.02517 15.7385 9.07549 15.6171C9.12582 15.4957 9.19958 15.3854 9.29255 15.2926L19.2926 5.29257C19.4802 5.10493 19.7347 4.99951 20.0001 4.99951C20.2654 4.99951 20.5199 5.10493 20.7076 5.29257C20.8952 5.48021 21.0006 5.7347 21.0006 6.00007C21.0006 6.26543 20.8952 6.51993 20.7076 6.70757L11.4138 16.0001L20.7076 25.2926Z",
    fill: "#050F4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredPrev);
export default __webpack_public_path__ + "static/media/coloredPrev.53a439460090c61f617c1f13373c30a0.svg";
export { ForwardRef as ReactComponent };